import React, { useContext } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { ThemeContext } from './ThemeContext';
import { darkTheme } from './theme';

const ThemeToggle = ({ sx }) => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <Tooltip title={theme === darkTheme ? 'Mudar para tema claro' : 'Mudar para tema escuro'}>
      <IconButton
        onClick={toggleTheme}
        sx={{
          ...sx, // Permite que o sx passado (como mt: 'auto') seja aplicado
        }}
      >
        {theme === darkTheme ? <Brightness7Icon /> : <Brightness4Icon />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;